export default {"src":"/_next/static/media/bolt.d64fde23.svg","height":20,"width":11,"blurWidth":0,"blurHeight":0};